import React, { MouseEvent } from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import CloudDownloadSharpIcon from "@mui/icons-material/CloudDownloadSharp";

//Custom Components
import TableHeaderButton from "./TableHeaderButton";
import { exportTableToExcel } from "@/lib/exportExcel";
import { ITableHeaderButtonExportProps } from "@/@types/ui/Table";

// Types
import { DCRecord } from "@/@types/lib/dataController";

function TableHeaderButtonExport(props: ITableHeaderButtonExportProps) {
  const { t } = useTranslation();
  const { dc, rows, records, tableName, viewName, exportLabel, ...rest } = props;

  const handleExport = function (evt: MouseEvent<HTMLButtonElement>) {
    const filteredRecords: DCRecord[] = [];
    for (let i = 0; i < rows.length; i++) {
      filteredRecords.push(records[parseInt(rows[i].id)]);
    }

    const fields = dc.getViewFields( viewName || "exportExcel");
    const obj = {
      records: filteredRecords,
      fields: fields,
      filename: tableName ? tableName : dc.filename ? dc.filename : "",
      t: t
    };
    exportTableToExcel(obj);
  };

  return (
    <TableHeaderButton
      startIcon={<CloudDownloadSharpIcon />}
      variant="outlined"
      {...rest}
      onClick={handleExport}
      sx={{ display: { xs: "none", sm: "flex" } }}
    >
      {t(exportLabel || "buttons.export_xlsx")}
    </TableHeaderButton>
  );
}

export default TableHeaderButtonExport;
